
    <a (click)="loginAs()">
      <i class="table-edit-btn fas fa-sign-in-alt" style="color:red;"></i>
      <span></span>
    </a>
  